/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';

/** Components */
import BaseLayout from './BaseLayout';
import ComplexMathKeypad from '../keypads/ComplexMath';

class ComplexMathLayout extends Component {
  render() {
    return (
      <div className="keypad-layout complex-math clearfix">
        <BaseLayout {...this.props} />
        <ComplexMathKeypad
          onKeyPressWrite={this.props.onKeyPressWrite}
          onKeyPressCmd={this.props.onKeyPressCmd}
        />
      </div>
    );
  }
}

export default ComplexMathLayout;
